import React from 'react';

type UserOverlayInfoProps = {
  name: string;
};

export const UserOverlayInfo = ({ name }: UserOverlayInfoProps): React.ReactNode => {
  return (
    <div className="flex items-center gap-x-2.5">
      <span className="text-sm">{name}</span>
    </div>
  );
};
